module.exports = __webpack_public_path__ + "static/media/instructor-2.a721b475.png";